const CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid']

/**
 * Shares the current page through the system share sheet, or copies its link
 * where the browser has none (most desktop browsers). Resolves to 'copied'
 * when the link went to the clipboard.
 */
export async function shareAccommodation(name: string): Promise<'shared' | 'copied'> {
  const canShare = 'share' in navigator

  // The sharer's own campaign parameters would attribute the recipient's
  // visit to the sharer's ad, so they are swapped for a share tag. The other
  // parameters (selected dates) are kept.
  const url = new URL(window.location.href)
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith('utm_') || CLICK_ID_PARAMS.includes(key)) {
      url.searchParams.delete(key)
    }
  }
  url.searchParams.set('utm_source', 'share')
  url.searchParams.set('utm_medium', canShare ? 'web_share' : 'copy_link')
  url.hash = ''

  if (canShare) {
    await navigator.share({ title: name, url: url.toString() }).catch(() => {})
    return 'shared'
  }

  await navigator.clipboard.writeText(url.toString())
  return 'copied'
}
